export default function getGasSaverCentValue(marketId?: string) {
  if (!marketId) {
    return '20¢+';
  }

  return marketId === 'new-england' ? '30¢' : '20¢';
}
